<template lang="pug">
  .content(v-if="contents && contents.length" ref="container")
    .content-wrap.clearfix
      .images(v-if="images && images.length" :class="imagePosition")
        PostImage(
          v-for="image in images" :key="image.id"
          :content="image"
          :count="images.length"
          :max-width="containerWidth"
          :shadow="shadow"
        )
      Heading(:heading="heading.title" :subHeading="heading.sub_title")
      div(v-if="content && content.text" v-html="content.text")
</template>

<script>
import { debounce } from '@/helpers';

import Heading from './Heading';
import PostImage from './PostImage';

export default {
    name: 'Post',
    data() {
        return {
            containerWidth: undefined
        };
    },
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Heading,
        PostImage
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        heading() {
            return this.contents.find(content => content.key === 'heading');
        },
        content() {
            return this.contents.find(content => content.key === 'content');
        },
        images() {
            return this.contents.filter(content => content.key === 'image');
        },
        imagePosition() {
            let position = 'left-float';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_position');
                if (setting && setting.value !== undefined) position = setting.value;
            }

            return position;
        },
        shadow() {
            let shadow = 'box-shadow-2';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'image_shadow');
                if (setting && setting.value !== undefined) shadow = setting.value;
            }

            return shadow;
        }
    },
    mounted() {
        if (this.imagePosition === 'left-float') {
            this.containerWidth = 200;
        } else {
            const calculateMaxWidth = () => {
                if (this.$refs.container) {
                    const style = getComputedStyle(this.$refs.container);
                    this.containerWidth = this.$refs.container.clientWidth;
                    this.containerWidth -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                }
            };

            window.addEventListener('resize', debounce(calculateMaxWidth, 100));
            calculateMaxWidth();
        }
    }
};
</script>

<style lang="sass" scoped>
.content
  @screen md
    .content-wrap
      .images.left-float
        float: left
        // width: 320px
        display: block
        // flex-shrink: 0
        margin-right: 30px
        padding-top: 6px
      .images.top-block
        margin-bottom: 25px
        display: flex
        flex-direction: column
        align-items: center
</style>
